import axios from "axios";
import React, { Component } from "react";
import AppConfig from "../../../config/AppConfig";
import { TabsEvaluasi } from "./components/TabsEvaluasi";
class Evaluasi extends Component {
    state = {
        ref_dosen_tetap : [],
        ref_ipk : [],
        ref_masa_studi: [],
        display : false,
    }
    
    componentDidMount(){
        this.setState({display:false});
        let id_institusi = localStorage.getItem("id_sp_temp");
        let userdata = JSON.parse(localStorage.getItem("userdata"));
        let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
        let id_sp = sessiondata.i_idunit;
        if(id_institusi !== ""){
        id_sp = id_institusi;
        }
        if(id_institusi === null){
        id_sp = sessiondata.i_idunit;
        }
        let session = "";
        if(this.props.idSp !== undefined) {
          id_sp = this.props.idSp
        }
        if(id_sp){
            session = 
            // "?token="+userdata.token+
            "?id_pengguna="+userdata.id_pengguna+
            "&id_unit="+ id_sp +
            "&id_role="+sessiondata.i_idrole;
        }
        let data_PT         = AppConfig.urlGetTarget;
        let rq_data              =  axios.get(data_PT + id_sp);
        axios.all([
          rq_data,
          ])
        .then(axios.spread((...responses) => {
            let resp             = responses[0];
            let ref = {
                refrensi : resp.data.result.target_penetapan,
              }
              this.setState({
                ref_dosen_tetap : ref.refrensi["DOSEN TETAP"],
                ref_ipk : ref.refrensi["IPK MINIMAL PADA JENJANG PENDIDIKAN"],
                ref_masa_studi : ref.refrensi["MASA STUDI MAKSIMAL PADA JENJANG PENDIDIKAN"],
                display: true,
              });
          })).catch(errors => {
            console.log(errors);
          });
        }
    render(){
        return(
            <>
                <TabsEvaluasi  ref_masa_studi={this.state.ref_masa_studi} ref_ipk={this.state.ref_ipk}  ref_dosen_tetap={this.state.ref_dosen_tetap} display={this.state.display}/>
            </>
        )
    }
}
export default Evaluasi;